module.exports = __webpack_public_path__ + "img/PL08490.8d6b658b.png";